module.exports = __webpack_public_path__ + "img/logo.791d9fb1.png";